import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'next-i18next';

import Link from 'components/Link';
import { useApp } from 'lib/contexts/save-in-app-context';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './RecentSearches.module.scss';

const RecentSearches: React.FC<{ className?: string }> = ({ className }) => {
  const { aiSearches } = useApp();
  const [t] = useTranslation('ai.search');
  const containerRef = React.useRef<HTMLDivElement>(null);

  if (aiSearches.length === 0) {
    return null;
  }

  return (
    <section className={cx(styles.container, className)} ref={containerRef}>
      <header className={styles.header}>
        <h3 className={styles.title}>{t('recent-searches.title')}</h3>
      </header>
      <ul className={styles.searches}>
        {aiSearches.map((aiSearch) => {
          const url = PAGE_ROUTES.AI_SEARCH_RESULTS.replace('[searchId]', aiSearch.id);
          return (
            <li className={styles.search} key={aiSearch.id}>
              <Link href={url} prefetch={false} className={styles.link}>
                {aiSearch.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default RecentSearches;
